import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, grey10, grey5 } from 'approot/shared/styles/colours.style';
import {
  spacing16,
  spacing4,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import {
  flexCentreAlignCss,
  flexColumnCss,
} from 'approot/shared/styles/flex.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { font30, font46 } from 'approot/shared/styles/typography.style';
import {
  baseDragItemBaseColour,
  InteractiveText,
} from '../../shared/interactive-drag-drop/interactive-drag.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';

export const InteractiveResponseZoomImage = styled.div`
  background-color: ${grey1};
  position: absolute;
  padding: ${rem(spacing16)};
  inset: 0;
  z-index: 4;
`;

export const InteractiveResponseZoomImageInner = styled.div`
  ${flexColumnCss}
  gap: ${rem(spacing16)};
  max-width: ${rem(500)};
  margin: 0 auto;
  width: 100%;
  height: 100%;
`;

type InteractiveResponseImageZoomContainerProps = {
  $baseColour?: string | null;
};
export const InteractiveResponseImageZoomContainer = styled(
  Box
).attrs<InteractiveResponseImageZoomContainerProps>({
  $alignItems: 'center',
  $justifyContent: 'center',
})<InteractiveResponseImageZoomContainerProps>`
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey10};
  flex-grow: 1;
  max-width: ${rem(500)};
  max-height: ${rem(500)};
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  ${baseDragItemBaseColour}
`;

export const InteractiveZoomContent = styled.div`
  width: 100%;
`;

export const InteractiveZoomTextContent = styled(InteractiveText)`
  ${font46}
`;

type InteractiveZoomTextImageContainerProps = {
  $isVisible: boolean;
};

export const InteractiveZoomContainerWrapper = styled.div`
  position: absolute;
  left: ${rem(spacing4)};
  right: ${rem(spacing4)};
  bottom: ${rem(spacing4)};
`;

export const InteractiveZoomTextImageContainer = styled.div<InteractiveZoomTextImageContainerProps>`
  ${font30}
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: ${rem(2)};
  border: 1px solid ${grey5};
  color: ${grey10};
  padding: ${rem(spacing4)};
  text-align: center;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
  transition:
    opacity 0.2s ease-in-out,
    visibility 0.2s ease-in-out;
`;

export const InteractiveZoomContainer = styled.div`
  position: absolute;
  top: ${rem(spacing16)};
  right: ${rem(spacing16)};

  ${SecondaryButtonIcon} {
    width: ${rem(72)};
    height: ${rem(72)};
    ${flexCentreAlignCss}

    svg {
      width: ${rem(24)};
      height: ${rem(24)};
    }
  }
`;

type InteractiveZoomControlsContainerProps = {
  $isVisible: boolean;
};
export const InteractiveZoomControlsContainer = styled.div<InteractiveZoomControlsContainerProps>`
  position: absolute;
  top: ${({ $isVisible }) => ($isVisible ? rem(-spacing16) : 'auto')};
  bottom: ${({ $isVisible }) => ($isVisible ? 'auto' : rem(spacing4))};
  right: ${rem(spacing4)};
  display: flex;
  gap: ${rem(spacing8)};
`;
